//@flow
import React, { Component } from 'react';

import * as Immutable from 'immutable';
import type { List, Map } from 'immutable';
import { Helmet } from 'react-helmet';
import { type TFunction } from 'react-i18next';
import FpPlanViewContainerHOC from './FpPlanViewContainerHOC';

import { Box } from '@locus-taxy/neo-ui';

import theme from './FpPlanViewContainer.scss';
import FpPlanViewVisitRouteContainer from './FpPlanViewVisitRouteContainer';

import ControlledSetInterval from 'common/utils/ControlledSetInterval';
import { type FpPjPlan } from 'common/models/internal/FpPjPlan';

type Props = {
    clientId: string,
    teamId: ?string,
    team: Map<string, any>,
    session: any,
    pjpId: string,
    planId: string,
    plan: ?FpPjPlan,
    allPlans: ?List<FpPjPlan>,
    fetchPjFpPlan: (clientId: string, pjpId: string) => void,
    pollFetchAllPlans: (clientId: string) => Function,
    isGlobalPersonnel: boolean,
    fetchSalesbeatPlan: (clientId: string, pjpId: string) => void,
    closeAllMapPopups: () => void,
    t: TFunction
};

type State = {
    isLoading: boolean
};

class FpPlanViewContainer extends Component<Props, State> {
    state: State;
    refreshInterval: number;
    planPollingHandler: ?ControlledSetInterval;

    constructor(props: Props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    shouldComponentUpdate(nextProps: Props) {
        const { allPlans: nextAllPlans } = nextProps;
        const { allPlans } = this.props;
        if (nextAllPlans !== allPlans) {
            return !Immutable.is(nextAllPlans, allPlans);
        }
        return true;
    }

    componentDidUpdate(prevProps) {
        const { clientId, planId, closeAllMapPopups } = this.props;
        const { clientId: prevClientId, planId: prevPlanId } = prevProps;
        if (clientId !== prevClientId || planId !== prevPlanId) {
            closeAllMapPopups();
        }
    }

    render() {
        const { t } = this.props;
        return (
            <Box height="fluid">
                <Helmet defer={false}>
                    <title>{t('fpPlanView.fieldProPlanView')}</title>
                </Helmet>
                <Box height="fluid">
                    <FpPlanViewVisitRouteContainer
                        {...this.props}
                        t={t}
                        theme={theme}
                    />
                </Box>
            </Box>
        );
    }
}

export default FpPlanViewContainerHOC(FpPlanViewContainer);
